/** 解析url */
export const parseURL = (url) => {
  const a = document.createElement('a')
  a.href = url
  return {
    source: url,
    protocol: a.protocol.replace(':', ''),
    host: a.hostname,
    port: a.port,
    query: a.search,
    params: (function () {
      const ret = {}
      const seg = a.search.replace(/^\?/, '').split('&')
      const len = seg.length; let i = 0; let s
      for (;i < len; i++) {
        if (!seg[i]) { continue }
        s = seg[i].split('=')
        ret[s[0]] = s[1]
      }
      return ret
    })(),
    file: (a.pathname.match(/([^/?#]+)$/i) || ['', ''])[1],
    hash: a.hash.replace('#', ''),
    path: a.pathname.replace(/^([^/])/, '/$1'),
    segments: a.pathname.replace(/^\//, '').split('/')
  }
}

/**
 * 获取调用时，到第二天的时间，返回时分秒的对象
 * @returns object { hour, minute, second }
 */
export const getNowToTomorrowTimer = function () {
  const numToStrWithTwoNumber = function (num) {
    return num < 10 ? `0${num}` : `${num}`
  }

  const hourTime = 60 * 60 * 1000
  const minuteTime = 60 * 1000
  const secondTime = 1000

  const tomorrow = new Date().setHours(0, 0, 0) + (24 * hourTime)
  const now = Date.now()
  const resultTime = tomorrow - now

  const hour = Math.floor(resultTime / hourTime)

  const m = (resultTime - (hour * hourTime)) // 减去hour才是分钟的时间
  const minute = Math.floor(m / minuteTime)

  const s = (m - (minute * minuteTime))
  const second = Math.floor(s / secondTime)
  return {
    hour: numToStrWithTwoNumber(hour),
    minute: numToStrWithTwoNumber(minute),
    second: numToStrWithTwoNumber(second)
  }
}
